import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.dashboard');
import { OnDestroy, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-dashboard',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.dashboard/view.scss */
/* src/app/page.dashboard/view.scss: no such file or directory */`],
})
export class PageDashboardComponent implements OnInit, OnDestroy {
    public loading: boolean = true;
    public sending: boolean = false;
    public user: any = {};
    public communities: any[] = [];
    public channels: any[] = [];
    public messages: any[] = [];
    public members: any[] = [];
    public availableMembers: any[] = [];
    public activeCommunityId: string = "";
    public activeRoomId: string = "";
    public messageText: string = "";
    public notificationPermission: string = "default";
    public showCreateCommunityModal: boolean = false;
    public creatingCommunity: boolean = false;
    public communityForm: any = {
        name: "",
        member_ids: []
    };
    public showCreateChannelModal: boolean = false;
    public creatingChannel: boolean = false;
    public channelForm: any = {
        name: ""
    };
    public poller: any = null;
    private lastMessageId: string = "";
    private focused: boolean = true;
    private onOpenCommunityModal = () => {
        this.openCreateCommunity();
    }

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
        this.notificationPermission = this.getNotificationPermission();
        window.addEventListener("focus", this.onFocus);
        window.addEventListener("blur", this.onBlur);
        window.addEventListener("season-open-community-modal", this.onOpenCommunityModal);

        const params = new URLSearchParams(location.search);
        this.activeCommunityId = params.get("community_id") || "";
        this.activeRoomId = params.get("room_id") || "";

        await this.bootstrap();
        if (params.get("newCommunity") === "1") {
            await this.openCreateCommunity();
        }
        if (params.get("newChannel") === "1") {
            await this.openCreateChannel();
        }
        this.startPolling();
    }

    public ngOnDestroy() {
        if (this.poller) clearInterval(this.poller);
        window.removeEventListener("focus", this.onFocus);
        window.removeEventListener("blur", this.onBlur);
        window.removeEventListener("season-open-community-modal", this.onOpenCommunityModal);
    }

    private onFocus = () => {
        this.focused = true;
    }

    private onBlur = () => {
        this.focused = false;
    }

    public getNotificationPermission() {
        if (!("Notification" in window)) return "unsupported";
        return Notification.permission;
    }

    public activeCommunity() {
        return this.communities.find(community => community.id === this.activeCommunityId) || this.communities[0] || null;
    }

    public activeRoom() {
        return this.channels.find(channel => channel.id === this.activeRoomId) || this.channels[0] || null;
    }

    public isMine(item: any) {
        return item.user_id === this.user?.id;
    }

    public messageCountText() {
        const count = this.messages.length;
        if (count === 0) return "대화 없음";
        return `${count}개의 메시지`;
    }

    public channelIcon(channel: any) {
        return channel?.channel_type === "notice" ? "fa-solid fa-bullhorn text-sm" : "fa-solid fa-hashtag text-sm";
    }

    public async bootstrap() {
        this.loading = true;
        await this.service.render();

        const { code, data } = await wiz.call("bootstrap", {
            community_id: this.activeCommunityId,
            room_id: this.activeRoomId
        });
        if (code === 200) {
            this.user = data.user || {};
            this.communities = data.communities || [];
            this.channels = data.channels || [];
            this.members = data.members || [];
            this.availableMembers = data.all_members || [];
            this.activeCommunityId = data.active_community || this.communities[0]?.id || "";
            this.activeRoomId = data.active_room || this.channels[0]?.id || "";
            this.messages = data.messages || [];
            this.lastMessageId = this.messages[this.messages.length - 1]?.id || "";
            this.updateRoute();
        }

        this.loading = false;
        await this.service.render();
        this.scrollToBottom();
    }

    public async selectChannel(channel: any) {
        if (!channel || channel.id === this.activeRoomId) return;
        this.activeRoomId = channel.id;
        this.messages = [];
        this.lastMessageId = "";
        this.updateRoute();
        await this.refreshMessages(false);
    }

    public async refreshMessages(silent: boolean = true) {
        if (!this.activeRoomId) return;
        if (!silent) {
            this.loading = true;
            await this.service.render();
        }

        const { code, data } = await wiz.call("messages", { room_id: this.activeRoomId });
        if (code === 200) {
            const nextMessages = data.messages || [];
            const nextLast = nextMessages[nextMessages.length - 1] || null;
            const hasNewMessage = nextLast && this.lastMessageId && nextLast.id !== this.lastMessageId;

            this.communities = data.communities || this.communities;
            this.channels = data.channels || this.channels;
            this.members = data.members || this.members;
            this.activeCommunityId = data.active_community || this.activeCommunityId;
            this.messages = nextMessages;

            if (hasNewMessage && !this.isMine(nextLast)) {
                await this.notifyNewMessage(nextLast);
            }

            this.lastMessageId = nextLast?.id || this.lastMessageId;
            this.updateRoute();
        }

        this.loading = false;
        await this.service.render();
        this.scrollToBottom();
    }

    public updateRoute() {
        const params = new URLSearchParams();
        if (this.activeCommunityId) params.set("community_id", this.activeCommunityId);
        if (this.activeRoomId) params.set("room_id", this.activeRoomId);
        const query = params.toString();
        history.replaceState({}, "", query ? `/dashboard?${query}` : "/dashboard");
    }

    public async openCreateCommunity() {
        this.communityForm = {
            name: "",
            member_ids: []
        };
        this.showCreateCommunityModal = true;
        await this.service.render();
    }

    public async closeCreateCommunity() {
        this.showCreateCommunityModal = false;
        await this.service.render();
    }

    public isMemberSelected(member: any) {
        return this.communityForm.member_ids.indexOf(member.id) >= 0;
    }

    public async toggleCommunityMember(member: any) {
        const memberIds = this.communityForm.member_ids;
        const index = memberIds.indexOf(member.id);
        if (index >= 0) {
            memberIds.splice(index, 1);
        } else {
            memberIds.push(member.id);
        }
        await this.service.render();
    }

    public selectedMemberCount() {
        return this.communityForm.member_ids.length + 1;
    }

    public async createCommunity() {
        const name = (this.communityForm.name || "").trim();
        if (!name) {
            await this.service.modal.error("커뮤니티 이름을 입력해주세요.");
            return;
        }
        if (this.creatingCommunity) return;

        this.creatingCommunity = true;
        await this.service.render();

        const { code, data } = await wiz.call("create_community", {
            name: name,
            member_ids: JSON.stringify(this.communityForm.member_ids)
        });

        this.creatingCommunity = false;
        if (code === 200) {
            this.showCreateCommunityModal = false;
            this.communities = data.communities || this.communities;
            this.channels = data.channels || [];
            this.members = data.members || [];
            this.availableMembers = data.all_members || this.availableMembers;
            this.activeCommunityId = data.active_community || data.community?.id || this.activeCommunityId;
            this.activeRoomId = data.active_room || data.channel?.id || this.activeRoomId;
            this.messages = data.messages || [];
            this.lastMessageId = this.messages[this.messages.length - 1]?.id || "";
            this.updateRoute();
            await this.service.render();
            this.scrollToBottom();
            return;
        }

        await this.service.modal.error(data?.message || "커뮤니티를 만들 수 없습니다.");
        await this.service.render();
    }

    public async openCreateChannel() {
        this.channelForm = {
            name: ""
        };
        this.showCreateChannelModal = true;
        await this.service.render();
    }

    public async closeCreateChannel() {
        this.showCreateChannelModal = false;
        await this.service.render();
    }

    public async createChannel() {
        const name = (this.channelForm.name || "").trim();
        if (!name) {
            await this.service.modal.error("채널 이름을 입력해주세요.");
            return;
        }
        if (!this.activeCommunityId || this.creatingChannel) return;

        this.creatingChannel = true;
        await this.service.render();

        const { code, data } = await wiz.call("create_channel", {
            community_id: this.activeCommunityId,
            name: name
        });

        this.creatingChannel = false;
        if (code === 200) {
            this.showCreateChannelModal = false;
            this.communities = data.communities || this.communities;
            this.channels = data.channels || this.channels;
            this.members = data.members || this.members;
            this.activeCommunityId = data.active_community || this.activeCommunityId;
            this.activeRoomId = data.active_room || data.channel?.id || this.activeRoomId;
            this.messages = data.messages || [];
            this.lastMessageId = "";
            this.updateRoute();
            await this.service.render();
            this.scrollToBottom();
            return;
        }

        await this.service.modal.error(data?.message || "채널을 만들 수 없습니다.");
        await this.service.render();
    }

    public startPolling() {
        if (this.poller) clearInterval(this.poller);
        this.poller = setInterval(() => {
            this.refreshMessages(true);
        }, 3500);
    }

    public async sendOnEnter(event: KeyboardEvent) {
        if (event.shiftKey) return;
        event.preventDefault();
        await this.sendMessage();
    }

    public async sendMessage() {
        const message = this.messageText.trim();
        if (!message || !this.activeRoomId || this.sending) return;

        this.sending = true;
        await this.service.render();

        const { code, data } = await wiz.call("send", {
            room_id: this.activeRoomId,
            message: message
        });

        if (code === 200) {
            this.messageText = "";
            this.communities = data.communities || this.communities;
            this.channels = data.channels || this.channels;
            this.messages.push(data.message);
            this.lastMessageId = data.message?.id || this.lastMessageId;
        } else {
            await this.service.modal.error(data?.message || "메시지를 보낼 수 없습니다.");
        }

        this.sending = false;
        await this.service.render();
        this.scrollToBottom();
    }

    public scrollToBottom() {
        setTimeout(() => {
            const target = document.getElementById("chat-scroll");
            if (target) target.scrollTop = target.scrollHeight;
        }, 30);
    }

    public async enableNotifications() {
        if (!("Notification" in window)) {
            await this.service.modal.error("현재 브라우저에서 알림을 지원하지 않습니다.");
            return;
        }

        const permission = await Notification.requestPermission();
        this.notificationPermission = permission;
        await this.service.render();

        if (permission !== "granted") return;

        try {
            if ("serviceWorker" in navigator) {
                const registration = await navigator.serviceWorker.ready;
                const subscription = await registration.pushManager?.getSubscription();
                if (subscription) {
                    await wiz.call("save_subscription", {
                        endpoint: subscription.endpoint,
                        subscription: JSON.stringify(subscription.toJSON())
                    });
                }
                await registration.showNotification("Season Chat", {
                    body: "알림이 켜졌습니다.",
                    icon: "/assets/brand/icon.ico",
                    tag: "season-chat-ready",
                    data: { url: "/dashboard" }
                });
            }
        } catch (e) {
            new Notification("Season Chat", { body: "알림이 켜졌습니다." });
        }
    }

    public async notifyNewMessage(item: any) {
        if (this.notificationPermission !== "granted") return;
        if (this.focused && document.visibilityState === "visible") return;

        const channel = this.activeRoom();
        const title = `${item.author_name} · ${channel?.name || "Season Chat"}`;
        const options: any = {
            body: item.message,
            icon: "/assets/brand/icon.ico",
            tag: `season-chat-${item.room_id}`,
            data: { url: "/dashboard", room_id: item.room_id }
        };

        try {
            if ("serviceWorker" in navigator) {
                const registration = await navigator.serviceWorker.ready;
                await registration.showNotification(title, options);
                return;
            }
        } catch (e) { }

        new Notification(title, options);
    }
}

export default PageDashboardComponent;